define('gumbo-js-client-lib/forms/liveData/AtbatForm',{
	atBatIndex: null,
	event: {
		brief: null,
		description: null,
		type: null
	},
	count: {
		numPitches: null,
		balls: null,
		strikes: null,
		outs: null
	},
	hasHighlight: null,
	inning: null,
	halfInning: null,
	isAction: null,
	isComplete: null,
	isPlay: null,
	isScoringPlay: null,
	pitches: null,
	startTfs: null,
	type: null
});
